<template>
  <component :is="layout">
    <router-view :key="$route.fullPath" />
  </component>
</template>
<script>
/* eslint-disable */

import { defineAsyncComponent } from "vue";
const Horizontal = defineAsyncComponent(
  () => import("@/views/Layouts/Horizontal.vue")
);
const Full = defineAsyncComponent(() => import("@/views/Layouts/Full.vue"));

export default {
  name: "App",
  components: {
    Full,
    Horizontal,
  },
  data() {
    return {};
  },
  methods: {},
  computed: {
    layout() {
      if (
        this.$route.meta.layout === "full" ||
        this.$route.meta.layout === undefined
      ) {
        return "full";
      } else {
        return `horizontal`;
      }
    },
  },
  beforeMount() {
    //this.$store.state.isTransparent = "bg-transparent";
  },
  mounted() {
    document.body.classList.remove("dark-version");
    // Log the page view when the app is mounted
    if (this.$analytics) {
      this.$analytics.logEvent("page_view", {
        page_path: window.location.pathname, // The current URL path
        page_title: document.title, // The title of the current page
      });
    }
  },
};
</script>
<style scoped></style>
